













import { Vue, Component } from 'vue-property-decorator'
import Title from '@/components/PageTitle.vue'
import { Action } from 'vuex-class'
import { Step } from '../store'

@Component({
  components: {
    Title
  }
})
export default class Finish extends Vue {
  @Action('stepTo') stepTo!: Function
  mounted () {
    this.stepTo(Step.Finish)
  }
}
